import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getElevenLabsBalances } from "../../dashboards/redux/dashboardApi";

export default function ElevenLabsBalanceHeader() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  const fetchBalances = () => {
    setLoading(true);
    dispatch(getElevenLabsBalances()).then((res) => {
      if (res) {
        setData(res);
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    fetchBalances();
    // Refresh balances every 5 minutes
    const interval = setInterval(fetchBalances, 5 * 60 * 1000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatNumber = (num) => {
    if (num == null) return "0";
    return num.toLocaleString();
  };

  if (loading && !data) {
    return (
      <div className="d-flex align-items-center" style={{ gap: "8px" }}>
        {/* <div 
          className="skeleton-pulse" 
          style={{ width: "120px", height: "28px", borderRadius: "20px" }}
        /> */}
        <div 
          className="skeleton-pulse" 
          style={{ width: "120px", height: "28px", borderRadius: "20px" }}
        />
      </div>
    );
  }

  if (!data) return null;

  // newDataCalling: Agent 4 now shares the primary ElevenLabs API key/phone
  // (see settings + elevenlabsService.js), so it no longer has its own
  // balance — kept in `data` but its dedicated pill below is commented out.
  //const { primary, newDataCalling, lastUpdated } = data;
  const { primary, lastUpdated } = data;
  // Format tooltip details
  const getTooltip = (item, name) => {
    if (!item || !item.configured) return `${name}: Not Configured`;
    if (item.isShared) return `${name}: Shared Primary Account`;
    const formatFull = (n) => n.toLocaleString();
    const lastUpdatedStr = lastUpdated ? new Date(lastUpdated).toLocaleTimeString() : "N/A";
    return `${name}\nRemaining: ${formatFull(item.remaining)} / ${formatFull(item.limit)} chars\nPlan Tier: ${item.tier || "N/A"}\nLast Updated: ${lastUpdatedStr}`;
  };

  return (
    <div className="d-flex align-items-center flex-wrap" style={{ gap: "10px" }}>
      <span 
        style={{ 
          fontWeight: "600", 
          color: "#2F3349", 
          fontSize: "0.86rem", 
          marginRight: "4px",
          fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
          letterSpacing: "0.2px"
        }}
      >
        ElevenLab's Available Credits:
      </span>
      {/* Primary Balance Pill */}
      {primary && primary.configured && (
        <div
          title={getTooltip(primary, "Primary Account (Agents 1-4)")}
          className="d-flex align-items-center"
          style={{
            padding: "6px 14px",
            backgroundColor: "#F5F8FA",
            color: "#3F4254",
            border: "1px solid #E4E6EF",
            borderRadius: "22px",
            fontSize: "0.86rem",
            cursor: "pointer",
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            transition: "all 0.15s ease-in-out"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#EEF2F5";
            e.currentTarget.style.borderColor = "#D8DCE6";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#F5F8FA";
            e.currentTarget.style.borderColor = "#E4E6EF";
          }}
        >
          <span style={{ fontWeight: "600", color: "#3F4254", marginRight: "6px", fontFamily: '"Inter", "Helvetica", "Arial", sans-serif' }}>Agent 1,2,3,4:</span>
          <span style={{ fontWeight: "600", color: "#3F4254", fontFamily: '"Inter", "Helvetica", "Arial", sans-serif' }}>{formatNumber(primary.remaining)}</span>
        </div>
      )}

      {/* New Data Calling / Agent 4 Balance Pill — Agent 4 now shares the
          primary account (see settings + elevenlabsService.js), so it no
          longer has a separate balance to show. Commented out rather than
          removed in case a dedicated Agent 4 key is reintroduced later.
      {newDataCalling && (newDataCalling.configured || newDataCalling.isShared) && (
        <div
          title={getTooltip(newDataCalling, "New Data Account (Agent 4)")}
          className="d-flex align-items-center"
          style={{
            padding: "6px 14px",
            backgroundColor: "#F5F8FA",
            color: "#3F4254",
            border: "1px solid #E4E6EF",
            borderRadius: "22px",
            fontSize: "0.86rem",
            cursor: "pointer",
            fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            transition: "all 0.15s ease-in-out"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#EEF2F5";
            e.currentTarget.style.borderColor = "#D8DCE6";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#F5F8FA";
            e.currentTarget.style.borderColor = "#E4E6EF";
          }}
        >
          <span style={{ fontWeight: "600", color: "#3F4254", marginRight: "6px", fontFamily: '"Inter", "Helvetica", "Arial", sans-serif' }}>Agent 4:</span>
          <span style={{ fontWeight: "600", color: "#3F4254", fontFamily: '"Inter", "Helvetica", "Arial", sans-serif' }}>
            {newDataCalling.isShared ? "Shared Account" : formatNumber(newDataCalling.remaining)}
          </span>
        </div>
      )}
      */}
    </div>
  );
}
